<template>
  <el-tabs type="card">
    <el-tab-pane v-for="ly in showLyricList" :key="ly.key" :label="lyricTitle(ly)">
      <!-- 先隐藏,以后不知道要不要改 -->
      <!-- <el-form-item label="歌词来源" label-width="100px">
        <el-select v-model="lyricData[ly.key].from" >
          <el-option v-for="(name, key) in lyricFromMap" :key="key" :label="key + '. ' + name" :value="+key"></el-option>
        </el-select>
      </el-form-item> -->
      <template v-if="ly.key==='lyricQrc'">
        <el-button type="primary" style="margin: 0 0 0 8px;" :disabled="disabled" @click="handleShowTrcMaker">制作歌词</el-button>
      </template>
      <el-button
        v-if="ly.key==='lyricTrans'"
        type="primary"
        style="margin: 0 0 0 8px;"
        :disabled="disabled"
        @click="handleShowTransMaker"
      >
        制作歌词
      </el-button>
      <div v-if="ly.key === 'lyricLrc'"><span style="color: red;">*</span>逐行歌词通过逐字歌词自动生成，请完善逐字歌词</div>
      <verify-uploader
        action="/action/upload?type=lyric"
        :on-preview="handleLyricPreview"
        :on-remove="handleLyricRemove(ly.key)"
        :before-upload="handleLyricUploadBefore(ly.key)"
        :on-success="handleLyricUploadSuccess(ly.key)"
        :on-error="handleLyricUploadError(ly.key)"
        :accept="ly.accept.join(',')"
        :show-file-list="true"
        :file-list="lyricData[ly.key].fileList"
        :disabled="disabled"
      >
        <template v-if="media && media.mediaUrl">
          <template v-if="ly.key === 'lyricTxt' || ly.key === 'lyricLrc'">
            <el-button type="primary" :disabled="disabled">上传歌词</el-button>
          </template>
        </template>

        <span v-else style="color: red;" @click.cancel.stop>请先上传音频文件</span>
        <span v-if="media && media.mediaUrl && ly.key === 'lyricTxt'" slot="tip" class="el-upload__tip">上传txt格式歌词文件</span>
      </verify-uploader>
    </el-tab-pane>

    <!-- 歌词制作 -->
    <el-dialog
      v-if="showLyricMaker"
      title="歌词制作"
      width="700px"
      @close="handleTrcClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="showLyricMaker"
      :append-to-body="true"
    >
      <lyric-maker
        ref="lyricMaker"
        v-loading="lyricMaking"
        :track="track"
        :txt-lyric-url="lyricData.lyricTxt.fileList[0].url"
        :media="media"
        @finish="handleTrcFinish"
      ></lyric-maker>
    </el-dialog>

    <!-- 翻译歌词制作 -->
    <el-dialog
      v-if="showTransLyricMaker"
      title="翻译歌词制作"
      width="1200px"
      @close="handleTransClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="showTransLyricMaker"
      :append-to-body="true"
    >
      <trans-lyric-maker
        ref="transLyricMaker"
        v-loading="lyricMaking"
        :track="track"
        :lrc-lyric-url="lyricData.lyricLrc.fileList[0] ? lyricData.lyricLrc.fileList[0].url : ''"
        :trans-lyric-url="lyricData.lyricTrans.fileList[0] ? lyricData.lyricTrans.fileList[0].url : ''"
        :media="media"
        @finish="handleTransFinish"
      ></trans-lyric-maker>
    </el-dialog>
  </el-tabs>
</template>

<script>
import cloneDeep from 'lodash-es/cloneDeep'
import commonService from '@/api/common'
import { getFileText } from '@/utils/fileUtil'
import verifyUploader from '@/components/VerifyUploader'
import LyricMaker from './LyricMaker'
import TransLyricMaker from './TransLyricMaker'
import { lyricFromMap, lyricList, lyricType as lyricTypeMap } from '../mixin.js'
import { validateFileExt } from '@/utils/validate'

const defaultLyric = {
  from: 0,
  fileList: []
}

export default {
  name: 'TrackLyric',
  components: {
    verifyUploader,
    LyricMaker,
    TransLyricMaker
  },
  props: {
    lyric: {
      type: Object,
      default() {
        return {}
      }
    },
    media: {
      type: Object
    },
    track: {
      type: Object
    },
    disabled: Boolean
  },
  data() {
    const lyricData = {}
    lyricList.forEach(lyricType => {
      lyricData[lyricType.key] = cloneDeep(defaultLyric)
    })
    return {
      lyricFromMap,
      lyricList,
      lyricData,
      lyricUploading: false,
      showLyricMaker: false,
      showTransLyricMaker: false,
      lyricMaking: false,
    }
  },
  computed: {
    /**
     * @returns {Array}
     */
    showLyricList() {
      return this.lyricList.filter(item => !item.hidden)
    }
  },
  watch: {
    lyric(newVal) {
      this.updateLyric(newVal)
    }
  },
  created() {
    this.updateLyric(this.lyric)
  },
  methods: {
    updateLyric(lyricData) {
      lyricList.forEach(lyricType => {
        if (lyricData[lyricType.key]) {
          this.lyricData[lyricType.key] = {
            from: lyricData[lyricType.key].fFrom,
            fileList: [{
              ...lyricData[lyricType.key],
              url: this.$toPreview(lyricData[lyricType.key].lyricUrl),
              name: lyricData[lyricType.key].fileName
            }]
          }
        } else {
          this.lyricData[lyricType.key] = {
            from: 7,
            fileList: []
          }
        }
      })
    },

    /**
     * @public
     */
    getLyricData() {
      return this.lyricData
    },

    lyricTitle(lyricConf) {
      let title = lyricConf.name
      title += this.lyricData[lyricConf.key].fileList.length ? '(有)' : ''
      return title
    },

    handleShowTrcMaker() {
      const { lyricData, track } = this
      const { trackName, media } = track
      if (lyricData.lyricTxt.fileList.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请先上传txt歌词'
        })
      }

      if (!trackName || !(media && media.mediaUrl)) {
        return this.$message({
          type: 'warning',
          message: '制作歌词前必须先填写歌曲名，上传音频！'
        })
      }

      this.showLyricMaker = true
    },
    handleShowTransMaker() {
      const { lyricData, track } = this
      const { trackName, media } = track
      if (lyricData.lyricLrc.fileList.length === 0) {
        return this.$message({
          type: 'warning',
          message: '请先上传LRC歌词'
        })
      }

      if (!trackName || !(media && media.mediaUrl)) {
        return this.$message({
          type: 'warning',
          message: '制作歌词前必须先填写歌曲名，上传音频！'
        })
      }

      this.showTransLyricMaker = true
    },

    handleTransFinish(transLyricObj) {
      this.uploadLyric(transLyricObj).then(resp => {
        const trackName = transLyricObj.lyricAST.songInfo.trackName
        const lyricdata = this.lyricData[transLyricObj.type]
        lyricdata.from = 0 // 人工制作
        lyricdata.fileList = [
          this.makeFile({ name: `${trackName}${transLyricObj.nameExt}.${transLyricObj.ext}` }, resp, 0)
        ]
        this.handleTransClose()
      }).catch(error => {
        console.error(error)
        this.$refs.transLyricMaker.submiting = false
        this.$message({
          type: 'error',
          messag: '歌词上传异常：' + error.message
        })
      }).finally(_ => {
        this.lyricMaking = false
      })
    },
    uploadLyric(lyricObj) {
      const trackName = lyricObj.lyricAST.songInfo.trackName
      const lyricFile = new File([lyricObj.lyricText], `${trackName}${lyricObj.nameExt}.${lyricObj.ext}`, {
        type: 'text/plain;charset=utf-8',
        lastModified: Date.now()
      })

      return commonService.upload('lyric', lyricFile)
    },
    makeFile(file, resp, from) {
      return {
        url: this.$toPreview(resp.url),
        name: file.name,
        fileName: file.name,
        lyricPath: resp.file_id,
        originalLyricPath: resp.file_id,
        lyricUrl: resp.url,
        originalLyricUrl: resp.url,
        fFrom: from,
        using: 1,
        fileMd5: resp.md5
      }
    },

    /**
     * @param {Object} txtObj
     * @param {Lyric} txtObj.trc 继承自 Lyric 的实例
     * @param {Lyric} txtObj.krc 继承自 Lyric 的实例
     * @param {Lyric} txtObj.lrcx 继承自 Lyric 的实例
     * @param {Lyric} txtObj.lrc 继承自 Lyric 的实例
     */
    handleTrcFinish(txtObj) {
      const lyricObjList = []
      const uploadPromiseList = []

      this.lyricMaking = true
      for (const key in txtObj) {
        if (txtObj.hasOwnProperty(key)) {
          const lyricObj = txtObj[key]

          // console.log(lyricObj)
          lyricObjList.push(lyricObj)
          uploadPromiseList.push(this.uploadLyric(lyricObj))
        }
      }

      // 上传到 cos
      Promise.all(uploadPromiseList).then(respList => {
        for (let i = 0; i < lyricObjList.length; i++) {
          const lyricObj = lyricObjList[i]
          const trackName = lyricObj.lyricAST.songInfo.trackName

          const lyricdata = this.lyricData[lyricObj.type]
          lyricdata.from = 7 // 人工制作
          lyricdata.fileList = [
            this.makeFile({ name: `${trackName}${lyricObj.nameExt}.${lyricObj.ext}` }, respList[i], 0)
          ]
        }
        this.handleTrcClose()
      }).catch(error => {
        console.error(error)
        this.$message({
          type: 'error',
          messag: '歌词上传异常：' + error.message
        })
      }).finally(_ => {
        this.lyricMaking = false
      })
    },

    handleTrcClose() {
      this.showLyricMaker = false
      this.showTrcEdit = false
    },
    handleTransClose() {
      this.showTransLyricMaker = false
    },

    handleLyricUploadError(lyricType) {
      return (error, file) => {
        console.error(error)
        this.mediaUploading = false
        this.$message({
          type: 'error',
          message: `<${lyricType}>歌词上传失败，请稍后重试`
        })
      }
    },

    handleLyricRemove(lyricType) {
      return (file, fileList) => {
        this.lyricData[lyricType].fileList = fileList
      }
    },

    handleLyricPreview(file) {
      open(file.url, '_blank')
    },

    handleLyricUploadBefore(lyricType) {
      return (file) => {
        if (!validateFileExt(lyricTypeMap, file.name)) {
          this.$message.warning('不支持的文件类型')
          return Promise.reject()
        }
        if (this.lyricUploading) return Promise.reject(false)

        return getFileText(file).then(async fileText => {
          let hasError = false

          if (lyricType === 'lyricTxt') {
            const errorRegList = [
              /\[\d{2}:\d{2}\.\d{2,3}\]/g,
              /\[\d{1,6},\d{1,6}\]/g,
              /\(\d{1,6},\d{1,6}\)/g
            ]
            hasError = errorRegList.some(reg => reg.test(fileText))
          } else {
            // 逐行歌词校验
            let sentence = fileText.split(/\r|\n|\r\n/g)

            // 1、去掉每行前后的不可见字符
            // 2、剔除空行
            sentence = sentence.map(s => {
              return s.trim()
            }).filter(s => {
              return s !== ''
            })
            hasError = sentence.some(s => {
              return !(/^\[[a-z]/.test(s) || /^\[[0-9]/.test(s))
            })
          }

          if (hasError) {
            try {
              await this.$confirm('歌词上传位置与歌词类型疑似不符合，确认上传吗?', '提示', {
                type: 'warning'
              })
            } catch (error) {
              return Promise.reject()
            }
          }

          if (this.lyricData[lyricType].fileList.length) {
            return this.$confirm('是否覆盖旧的歌词文件?', '提示', {
              confirmButtonText: '覆盖',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.mediaUploading = true
              return Promise.resolve()
            }).catch(() => {
              return Promise.reject()
            })
          }
          this.mediaUploading = true
          return Promise.resolve()
        }, (error) => {
          this.$alert(`解析歌词文件异常: ${error}`)
        }).catch(_ => {
          // this.$alert(`解析歌词文件异常: ${error}`)
          return Promise.reject()
        })
      }
    },

    handleLyricUploadSuccess(lyricType) {
      return (resp, file, fileList) => {
        this.mediaUploading = false
        const respData = resp.data
        const lyricObj = this.lyricData[lyricType]
        lyricObj.fileList = [
          {
            url: this.$toPreview(respData.url),
            name: file.name,
            fileName: file.name,
            lyricPath: respData.file_id,
            originalLyricPath: respData.file_id,
            lyricUrl: respData.url,
            originalLyricUrl: respData.url,
            fFrom: lyricObj.from,
            using: 1,
            fileMd5: respData.md5
          }
        ]
      }
    },

  }
}
</script>
